import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class NotificationService {
    static getAdminDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getAllSubscriptions(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'getAllSubscriptions', [], additionalHeaders);
    }

    static getSubscriptionsById(billingId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'getSubscriptionsByID', [billingId], additionalHeaders);
    }

    static getBCOwnerSubscriptions(ownerId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'getOwnerSubscriptions', [ownerId], additionalHeaders);
    }

    static createBCSubscription(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'createOwnerSubscription', [data], additionalHeaders);
    }

    static updateBCSubscription(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'updateOwnerSubscription', [data], additionalHeaders);
    }

    static deleteBCSubscription(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
            'deleteOwnerSubscription', [data], additionalHeaders);
    }


    // static updatePCSubscription(data, additionalHeaders = {}) {
    //     return JsonRPCService.send(getProxiedServiceUrl('BCNotification'),
    //         'updateOwnerSubscription', [data], additionalHeaders);
    // }

    static getSubscriptionsByPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('PCNotification'),
            'getAllSubscriptions', [policyNumber], additionalHeaders);
    }

    static updatePCSubscription(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('PCNotification'),
            'updateSubscription', [data], additionalHeaders);
    }
}
